// @ constants
const { EURO_SYMBOL } = require('constants/index');
const step1 = require('./step1');
const step2 = require('./step2');
const successStep = require('./successStep');
const customErrors = require('./customErrors');
const {
    PAYROLL_ACCOUNT_TYPE,
    PAYROLL_ACCOUNT_SUBTYPE,
    PAYROLL_ACCOUNT_STANDARD
} = require('constants/index');
const {
    PAYROLL_ACCOUNT_ALIAS,
    UPGRADE_TO_PAYROLL_ACCOUNT_ALIAS,
} = require('constants/hiringProductInformation');
// @ helpers
const { formatText } = require('core/i18n').i18n;

const contract = {
    title: 'contractsView-upgradeToPayrollAccountAccountPreselected',
    last_step: 3,
    define_steps: 2,
    onCancelURL: '/myprofile/accounts',
    termsAndCondsKey: UPGRADE_TO_PAYROLL_ACCOUNT_ALIAS,
    code_op: 110,
    showIntervenerControls: false,
    successStepType: 'dynamic',
    hireParamsFn: 'upgrade_to_payroll_account_HireParams',
    SignParamsFn: 'upgrade_to_payroll_account_SignParams',
    showHelpBar: true,
    errorTitle: 'contractsView-upgradeToPayrollAccountErrorTitle',
    errorMessage: 'contractsView-upgradeToPayrollAccountErrorMessage',
    errorBackButtonLabel: 'contractsView-upgradeToPayrollAccountErrorBackButtonLabel',
    errorBackButtonLink: '/myprofile/global',
    hasPrecontractualLink: true,
    accountAlias: PAYROLL_ACCOUNT_ALIAS,
    type: PAYROLL_ACCOUNT_TYPE,
    subtype: PAYROLL_ACCOUNT_SUBTYPE,
    standard: PAYROLL_ACCOUNT_STANDARD,
    warningContractMessage: 'contractsView-upgradeToPayrollAccountComponentInformationLabel',
    promo_code: true,
    operativeName:"operatives-upgradetoPayrollAccount",
    onlyUpgradeableToPayroll: true,
    breadcrumb: [
        {
            text: 'breadcrumb-accounts',
            url: '/myprofile/accounts'
        },
        {
            text: 'contractsView-upgradeToPayrollAccountAccountPreselected'
        }
    ],
    state: {
        card_details_title: 'contractsView-cardDetailsTitle',
        card_details: [
            {
                id: 'cta_seleccionada',
                label: 'contractsView-upgradeToPayrollAccountAccountToConvert',
                value: null,
                description: null,
                type: 'single',
                format_type: '',
                order: 1,
                confirmation_step: {
                    columns: 5,
                    order: 1,
                    row: 1
                },
                visible: [
                    {
                        step: 1,
                        order: 1
                    },
                    {
                        step: 2,
                        order: 1
                    },
                    {
                        step: 3,
                        order: 1
                    }
                ],
                isErrorVisible: false
            },
            {
                id: 'balance_account',
                label: 'contractsView-upgradeToPayrollAccountBalanceAssociated',
                value: null,
                type: 'single',
                formatNumber: true,
                format_type: EURO_SYMBOL,
                order: 7,
                confirmation_step: {
                    columns: 4,
                    highlighted: true,
                    order: 2,
                    row: 1
                },
                visible: [
                    {
                        step: 1,
                        order: 2
                    },
                    {
                        step: 2,
                        order: 2
                    },
                    {
                        step: 3,
                        order: 2
                    }
                ]
            },
            {
                id: 'cta_separator',
                type: 'separator',
                order: 3,
                label: 'cta_separator',
                visible: [
                    {
                        step: 1,
                        order: 3
                    },
                    {
                        step: 2,
                        order: 3
                    },
                    {
                        step: 3,
                        order: 3
                    }
                ]
            },
            {
                id: 'intervinientes_list',
                label: 'contractsView-interveners',
                value: null,
                type: 'interveners',
                format_type: '',
                order: 4,
                visible: [
                    {
                        step: 1,
                        order: 4
                    },
                    {
                        step: 2,
                        order: 4
                    },
                    {
                        step: 3,
                        order: 4
                    }
                ]
            },
            {
                id: 'cta_separator',
                type: 'separator',
                order: 3,
                label: 'cta_separator',
                visible: [
                    {
                        step: 3,
                        order: 5
                    }
                ]
            },
            {
                id: 'promotion',
                type: 'promotion',
                visible: [
                    {
                        step: 3,
                        order: 6
                    }
                ]
            },
            {
                id: 's_accounts',
                label: '',
                value: null,
                type: 'array',
                format_type: '',
                order: 10,
                visible: []
            },
            {
                id: 'n_steps',
                label: '',
                value: 3,
                type: 'array',
                format_type: '',
                order: 10,
                visible: []
            },
            {
                id: 'hasAccountPreselected',
                value: false
            }
        ],
        confirmationCheckboxes: {
            areValid: false,
            list: [
                {
                    id: 'service_contract_checkbox',
                    idName: 'serviceContract',
                    value: false,
                    isRequired: true,
                    errorState: false,
                    errorMessage: 'contractsView-serviceContractErrorMessage',
                    labels: [
                        {
                            text: 'contractsView-upgradeToPayrollAccountServiceContractLabel1'
                        },
                        {
                            text: 'contractsView-upgradeToPayrollAccountServiceContractLabel2',
                            id: 'btn_ContractsView_precontractual',
                            href: 'contractsView-upgradeToPayrollAccountServiceContractLabel2URL'
                        },
                        {
                            text: 'contractsView-upgradeToPayrollAccountServiceContractLabel3'
                        },
                        {
                            text: 'contractsView-upgradeToPayrollAccountServiceContractLabel4',
                            id: 'btn_ContractsView_product',
                            href: 'contractsView-upgradeToPayrollAccountServiceContractLabel4URL'
                        },
                        {
                            text: 'contractsView-upgradeToPayrollAccountServiceContractLabel4.1'
                        },
                        {
                            text: 'contractsView-upgradeToPayrollAccountServiceContractLabel4.2',
                            id: 'btn_ContractsView_product',
                            href: 'contractsView-upgradeToPayrollAccountServiceContractLabel4.2URL'
                        },
                        {
                            text: 'contractsView-upgradeToPayrollAccountServiceContractLabel5'
                        }
                    ]
                }
            ]
        },
        preContractDocuments : {
            preContractPdfFileName: "documentosCuentaNóminaOpen",
            preContractPdfTitle: formatText('preContractDocument-preContractDocument_payrollAccountPdfTitle')
        }
    },
    steps: [step1, step2],
    successStep,
    customErrors
};

module.exports = { contract };
